import { createSelector } from '@ngrx/store';
import { getRetailReviewPage } from './index';

/**
 * Exports retail specification state
 */
export const getPricesState = createSelector(
  getRetailReviewPage,
  state => {
    return state.pricesState;
  },
);
